import { Title, Container, Paragraph, FixedBottom, Button, HalvaBanner } from '@/components'
import styles from './PaymentResult.module.scss'
import getFullDate from '@/helpers/getFullDate'
import Link from 'next/link'
import getLinkHref from '@/helpers/getLinkHref'
import { supportPhoneLink } from '@/constants'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { RootState } from '@/store'
import { MobileApp } from '@/components/MobileApp/MobileApp'
import { DownloadAppBottomSheet } from '@/components/DownloadAppBottomSheet/DownloadAppBottomSheet'

export default function PaymentSubscriptionSuccessByAppPage({
  paidUntil,
  area,
}: {
  paidUntil?: string | null
  area: {
    id: string
    customising?: { button_back_color: string | null }
  } | null
}) {
  const date = getFullDate(paidUntil || '', true)
  const areaHref = getLinkHref({ type: 'area', data: { id: area?.id } })
  const reduxState = useSelector<RootState, RootState>(state => state)
  const receiptLink = reduxState.stages.payment.data.receiptLink
  const router = useRouter()

  const redirectToReceiptPage = () => {
    if (receiptLink) {
      router.push(receiptLink)
    }
  }

  const text = date
    ? `${date.day}.${date.month}.${date.year} ${date.hours}:${date.minutes}:${date.seconds}`
    : ''

  return (
    <>
      <section className={styles.section}>
        <Container className={styles.container}>
          <HalvaBanner />
          <div className={styles.successResultContent}>
            <img
              className={styles.sign__Error__icon}
              src="/images/payment-success.svg"
              alt="logo"
              width={87}
              height={87}
            />

            <Title align="center">Оплата успешно прошла</Title>

            <div className={styles.subscriptionInfo}>
              {date && (
                <Paragraph align="center" className={styles.section__descr}>
                  Действителен до {text}.
                </Paragraph>
              )}
              <Paragraph align="center" className={styles.section__text}>
                Держите номер авто чистым для автоматического открытия шлагбаума.
              </Paragraph>
            </div>
          </div>

          <FixedBottom isHide>
            <Container className={styles.buttons}>
              {receiptLink && (
                <Button
                  component="button"
                  className={styles.button}
                  onClick={redirectToReceiptPage}
                >
                  Получить чек
                </Button>
              )}

              <Link href={areaHref} passHref>
                <Button
                  component="a"
                  className={styles.button}
                  background={area?.customising?.button_back_color}
                >
                  На главную
                </Button>
              </Link>

              <Button component="a" href={supportPhoneLink} className={styles.button} isTransparent>
                Обратиться в поддержку
              </Button>
            </Container>
          </FixedBottom>

          <div className={styles.container__mobileApp}>
            <MobileApp />
          </div>
        </Container>
      </section>
      <DownloadAppBottomSheet />
    </>
  )
}
